import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import clsx from "clsx";
import {Button, Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import {useForm, FormProvider} from "react-hook-form";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {creaAgendaPrenotazioni} from "../../../../services/TamponiServices";
import {AppContext} from "../../../../App";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AgendaForm} from "./AgendaForm";

const AddAgendaCard = () => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const methods = useForm({
		mode: "onChange",
	});
	const [submit, setSubmit] = useState(false);
	let fasce = new Array(12).fill(":00");
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		let dataAgenda = new Date(data.data);
		dataAgenda?.setHours(0);
		dataAgenda?.setMinutes(0);
		dataAgenda?.setSeconds(0);
		dataAgenda?.setMilliseconds(0);
		let agenda = {
			...data,
			data: dataAgenda,
			postiR: data.postiI,
		};
		let totI = 0;
		let totR = 0;
		for (let i = 1; i <= fasce.length; i++) {
			agenda = {
				...agenda,
				["fascia" + i + "R"]: data["fascia" + i + "I"] ? data["fascia" + i + "I"] : 0,
			}
			totI += parseInt(agenda["fascia" + i + "I"]);
			totR += parseInt(agenda["fascia" + i + "R"]);
		}
		agenda = {
			...agenda,
			postiI: totI,
			postiR: totR,
		}
		creaAgendaPrenotazioni(agenda, dispatch)
	}, [dispatch, fasce])
	
	useEffect(() => {
		if (submit && !state.loadingAddAgenda && state.errorAddAgenda === "") {
			setSubmit(false);
			methods.reset();
			setOpenSnackbar("success", "Agenda creata con successo", appContext.dispatch);
		} else if (submit && !state.loadingAddAgenda && state.errorAddAgenda !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorAddAgenda, appContext.dispatch);
		}
	}, [submit, state.loadingAddAgenda, state.errorAddAgenda, appContext.dispatch, methods])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)} style={{display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Crea l'agenda per le prenotazioni dei tamponi</b></Typography>}
				/>
				<CardContent style={{flexGrow: 1}}>
					<FormProvider {...methods}>
						<AgendaForm fasce={fasce}/>
					</FormProvider>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip title={"Conferma e crea l'agenda"}>
						<Button variant={"contained"} size={"small"} color={"primary"} disableElevation disabled={submit}
						        style={{borderRadius: 24}}
						        onClick={methods.handleSubmit(onSubmit)} className={classes.roundButton}>
							<b>Conferma</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(AddAgendaCard)
